/**
 * i18n Prefix Override Utility
 *
 * Remaps CIVICS.* translation keys to BILLING.* (or any configured prefix)
 * at runtime, with fallback to the original CIVICS key if the overridden
 * key does not exist.
 *
 * Usage: Set window._i18nPrefixOverride = 'BILLING' before calling performPreCheck().
 * The base widget calls apply() automatically during performPreCheck().
 *
 */
define(['handlebars'], function (Handlebars) {
	var patched = false;

	return {
		// Must be called during portlet init(), not at module load time.
		// This is to fix issue where the fallback CIVICS.* always fire on first load
		// We intercept to make sure we are the last one to re-register the helper()
		// The patched flag is safe it simply prevents double-patching when multiple portlets call apply().
		apply: function () {
			if (patched) {
				return;
			}
			patched = true;

			var originalT = i18n.t.bind(i18n);

			i18n.t = function (key, options) {
				var prefix = window._i18nPrefixOverride;
				if (!prefix) {
					return originalT(key, options);
				}

				if (typeof key === 'string') {
					key = remapWithFallback(key, prefix, originalT);
				} else if (Array.isArray(key)) {
					key = key.map(function (k) {
						return remapWithFallback(k, prefix, originalT);
					});
				}

				return originalT(key, options);
			};

			// Re-register the Handlebars 't' helper so it goes through our patched i18n.t
			Handlebars.registerHelper('t', function (key, options) {
				var opts = options?.hash || {};
				return new Handlebars.SafeString(i18n.t(key, opts));
			});
		}
	};

	function remapWithFallback(key, prefix, originalT) {
		if (typeof key !== 'string' || !key.startsWith('CIVICS.')) {
			return key;
		}
		var remappedKey = key.replace(/^CIVICS\./, prefix + '.');
		// Use originalT to check existence — i18next 1.x returns the key itself when not found
		var result = originalT(remappedKey);
		if (result !== remappedKey) {
			return remappedKey;
		}
		return key;
	}
});
